import React from 'react';
import { Box } from '@mui/material';

// PNG 파일 동적 로드
const pngContext = require.context('./organizationEmblems', false, /^\.\/level=\d+\.png$/);

// PNG 파일 매핑 생성
const pngMap = {};
pngContext.keys().forEach((key) => {
    const match = key.match(/level=(\d+)\.png$/);
    if (match) {
        const level = parseInt(match[1], 10);
        pngMap[level] = pngContext(key);
    }
});

// 레벨에 맞는 PNG 파일 반환
const getPngForLevel = (level) => {
    const paddedLevel = String(level).padStart(2, '0');
    const numericLevel = parseInt(paddedLevel, 10);

    if (pngMap[numericLevel]) {
        return pngMap[numericLevel];
    }

    // 파일이 없을 경우 기본값 반환
    console.warn(`PNG file not found for level ${level}`);
    return pngMap[1] || pngContext('./level=01.png');
};

/**
 * 기관 엠블럼 컴포넌트
 * @param {number} level - 엠블럼 레벨 (1-100)
 * @param {number} size - 엠블럼 크기 (기본값: 70)
 * @param {object} sx - Material-UI sx prop
 */
export const OrganizationEmblem = ({ level = 1, size = 70, sx = {}, ...props }) => {
    const displayLevel = Math.min(Math.max(level, 1), 100);

    return (
        <Box
            sx={{
                position: 'relative',
                width: size,
                height: size,
                ...sx
            }}
            {...props}
        >
            {/* 배경 이미지 (PNG 또는 SVG) */}
            <Box
                component="img"
                src={getPngForLevel(displayLevel)}
                alt={`Organization Emblem Level ${level}`}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    pointerEvents: 'none',
                    zIndex: 1,
                }}
            />
            {/* 그림자 (radial-gradient) */}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '-8px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: size,
                    height: `${size * 0.143}px`, // 약 10px (70px 기준)
                    background: 'radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%)',
                    pointerEvents: 'none',
                    zIndex: 0,
                }}
            />
        </Box>
    );
};

export default OrganizationEmblem;

